'use client';

import React, { Suspense } from 'react';
import LoginChooser from './LoginChooser';

export default function LoginPage() {
  return (
    <Suspense
      fallback={
        <div className="min-h-screen bg-[#f0f4f8] flex items-center justify-center">
          <div className="w-8 h-8 border-2 border-[#1e3a5f] border-t-transparent rounded-full animate-spin" />
        </div>
      }
    >
      <LoginChooser />
    </Suspense>
  );
}
